/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { CalendarTasksGroup } from './calendar-tasks-group';
import { CalendarTask } from './calendar-task';

export class CalendarTaskHeaderGroup {
  public id: string;
  public label: string;

  public tasksGroups: CalendarTasksGroup[];
  public totalTasksDuration = 0;

  public isOpened = true;

  constructor(id: string, label: string) {
    this.id = id;
    this.label = label;
    this.tasksGroups = [];
  }

  public addGroup(id: string, label: string) {
    this.tasksGroups.push(new CalendarTasksGroup(id, label));
  }

  addTask(d: CalendarTask) {
    const group = this.tasksGroups.find((gr) => gr.id === d.group.group);
    if (group) {
      group.addTask(d);
      this.computeTotalTasksDuration();
    }
  }

  public computeTotalTasksDuration() {
    let total = 0;
    for (const resource of this.tasksGroups) {
      total += resource.totalTasksDuration;
    }
    this.totalTasksDuration = total;
  }
}
